import React, { Component } from "react";
import Layout from "../Layout/layout";
import { Helmet } from "react-helmet";
import "../styles/home/home.scss";
import { Tabs, Tab } from "react-bootstrap";
import CardBox from "./home/cardBox";
import HardwareFilterBox from "./home/hardwareFilterBox";
import DepotTable from "./home/depotTable";
import AwaitingTable from "./home/awaitingTable";
import UninstalledTable from "./home/uninstalledTable";
import PowercutTable from "./home/powercutTable";
import DuressTable from "./home/duressTable";
import { apiHost } from "../api/apiClient";
import { saveAs } from "file-saver";
import axios from "axios";
import HtmlContent from "./commoncomponents/htmlContent";
import "./../styles/tools/colors.scss";
import signalRHelper from "../utils/signalRHelper";
import { utcToDate, utcToHomeDate } from "../utils/dateConvert";
import { rounding } from "../utils/math";

const MAINTENANCE_DATE_THRESHOLD_KEY = "maintenance_due_date_threshold_days";
const MAINTENANCE_KM_THRESHOLD_KEY = "maintenance_due_km_threshold";

const getMaintenanceValue = (obj, key) => {
  if (!obj) return null;
  if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
  const pascal = key.charAt(0).toUpperCase() + key.slice(1);
  return obj[pascal];
};

const toMaintenanceNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const parseMaintenanceDueDate = (value) => {
  if (!value || value === "0000-00-00") return null;
  const parts = String(value).slice(0, 10).split("-").map(Number);
  if (parts.length !== 3 || parts.some((part) => !Number.isFinite(part))) {
    return null;
  }
  const date = new Date(parts[0], parts[1] - 1, parts[2]);
  date.setHours(0, 0, 0, 0);
  return date;
};

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableContent: false,
      hardwareFilter: "all",
      activeDashboardTab: "duress",
      depotList: [],
      totalDepots: "",
      awaitingList: [],
      awaitingInstallAsset: "",
      uninstalledList: [],
      maintenanceList: [],
      notRespondingList: [],
      powerCutList: [],
      duressList: [],
      maintenanceDueRows: [],
      maintenanceDueLoading: false,
      maintenanceDueError: "",
      totalAsset: "",
      activeAsset: "",
      activeCount: "",
      awaitingCount: "",
      uninstalledCount: "",
      maintenanceCount: "",
      notrespondingCount: "",
      respondingCount: "",
      realRespondingCount: "",
      activePercentage: "",
      awaitPercentage: "",
      uninstalledPercentage: "",
      maintenancePercentage: "",
      notrespondingPercentage: "",
      firstActivePercentage: "",
      firstUninstalledPercentage: "",
      firstAwaitingPercentage: "",
      inDepotPercentage: "",
      inDepot: "",
      depotLoading: false,
    };
    this.totalAsset = 0; //
    this.awaitinginstallcount = 0; //
    this.uninstallcount = 0; //
    this.active = 0;
    this.notresponding = 0; //
    this.dataSet = {};
    this.dashboardRequestId = 0;
  }
  componentDidMount() {
    this.loadDashboardData();
    if (this.props.showMaintenanceDueTile) {
      this.loadMaintenanceDueSummary();
    }
    this.handleSignalR();
  }

  componentWillUnmount() {
    this.releaseSignalR();
  }

  getHardwareFilterQuery = () => `hardwareType=${this.state.hardwareFilter}`;

  getAuthConfig = () => ({
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  });

  handleDashboardError = (e) => {
    if (e.response && e.response.status == "401") {
      this.props.history.push("/login");
    }
  };

  getStoredMaintenanceNumber = (key, fallback) => {
    const parsed = Number(localStorage.getItem(key));
    return Number.isFinite(parsed) && parsed >= 0 ? parsed : fallback;
  };

  loadMaintenanceDueSummary = async () => {
    this.setState({ maintenanceDueLoading: true, maintenanceDueError: "" });
    try {
      const response = await axios.get(`${apiHost}/api/Assets/MaintenanceDue`, this.getAuthConfig());
      this.setState({
        maintenanceDueRows: response.data || [],
        maintenanceDueLoading: false,
      });
    } catch (e) {
      if (e.response && e.response.status == "401") {
        this.props.history.push("/login");
        return;
      }

      this.setState({
        maintenanceDueLoading: false,
        maintenanceDueError: "Unable to load maintenance due",
      });
    }
  };

  handleHardwareFilterChange = (hardwareFilter) => {
    if (hardwareFilter === this.state.hardwareFilter) {
      return;
    }

    this.dataSet = {};
    this.setState({
      hardwareFilter,
      depotList: [],
      awaitingList: [],
      uninstalledList: [],
      maintenanceList: [],
      notRespondingList: [],
      powerCutList: [],
      duressList: [],
      totalDepots: "",
      totalAsset: "",
      activeAsset: "",
      awaitingCount: "",
      uninstalledCount: "",
      maintenanceCount: "",
      notrespondingCount: "",
      inDepot: "",
      inDepotPercentage: "",
      depotLoading: true,
    }, () => this.loadDashboardData(hardwareFilter));
  };

  releaseSignalR() {
    if (!this.connection) {
      return;
    }

    // Release signalR handlers
    signalRHelper.unsubscribe('Duress');
    signalRHelper.unsubscribe('RealTimeAssetsAdd');
    signalRHelper.unsubscribe('RealTimeAssetsUpdate');
    signalRHelper.unsubscribe('RealTimeDepotAdd');
    signalRHelper.unsubscribe('RealTimeNotResponding');
    signalRHelper.unsubscribe('Powercut');

    this.connection.off("Duress");
    this.connection.off("RealTimeAssetsAdd");
    this.connection.off("RealTimeAssetsUpdate");
    this.connection.off("RealTimeDepotAdd");
    this.connection.off("RealTimeNotResponding");
    this.connection.off("Powercut");
    this.connection = null;
  }

  //abhilash created
  handleDuressAndBehaviourCall = async () => {
    try {
      let alertsList = await axios.get(`${apiHost}/api/Event/GetLatestEvents`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      this.setState({
        duressList: alertsList.data.Duress,
      });

    } catch (e) {
      this.props.setErrorMessageAction(`${e}`);
      console.log(`😱 Axios request failed: ${e}`);
    }
  }
  //abhilash created
  handleNotificationCall = async () => {
    try {
      let notification = await axios.get(
        `${apiHost}/api/Notification/LatestNotification`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setState({ alertsNotificationList: notification.data });
      this.notificationPendingAlertCalculation();
    } catch (e) {
      this.props.setErrorMessageAction(`${e}`);
      console.log(`😱 Axios request failed: ${e}`);
    }
  }

  calculateDashboardMetrics = (dataSet) => {
    const {
      totalAsset,
      awaitingInstallAsset,
      uninstalledAsset,
      maintenanceAsset,
      responding,
      inDepot,
    } = dataSet;
    const totalAssetCount = parseInt(totalAsset) || 0;
    const awaitingInstallCount = parseInt(awaitingInstallAsset) || 0;
    const uninstalledCount = parseInt(uninstalledAsset) || 0;
    const maintenanceCount = parseInt(maintenanceAsset) || 0;
    const notRespondingCount = parseInt(responding) || 0;
    const inDepotCount = parseInt(inDepot) || 0;

    let activeAssets = totalAssetCount - awaitingInstallCount - uninstalledCount;

    let firstActivePercentage = Math.round((activeAssets / totalAssetCount) * 100);
    if (isNaN(firstActivePercentage)) firstActivePercentage = 0;

    let firstUninstalledPercentage = Math.round((awaitingInstallCount / totalAssetCount) * 100);
    if (isNaN(firstUninstalledPercentage)) firstUninstalledPercentage = 0;

    let firstAwaitingPercentage = Math.round((uninstalledCount / totalAssetCount) * 100);
    if (isNaN(firstAwaitingPercentage)) firstAwaitingPercentage = 0;

    let realRespondingCount = activeAssets - notRespondingCount;
    if (isNaN(realRespondingCount)) realRespondingCount = 0;

    let activePercentage = Math.round(((activeAssets - notRespondingCount) / activeAssets) * 100);
    if (isNaN(activePercentage)) activePercentage = 0;

    let awaitPercentage = Math.round((awaitingInstallCount / totalAssetCount) * 100);
    if (isNaN(awaitPercentage)) awaitPercentage = 0;

    let uninstalledPercentage = Math.round((uninstalledCount / totalAssetCount) * 100);
    if (isNaN(uninstalledPercentage)) uninstalledPercentage = 0;

    let maintenancePercentage = Math.round((maintenanceCount / notRespondingCount) * 100);
    if (isNaN(maintenancePercentage)) maintenancePercentage = 0;

    let notrespondingPercentage = Math.round((notRespondingCount / activeAssets) * 100);
    if (isNaN(notrespondingPercentage)) notrespondingPercentage = 0;

    let inDepotPercentage = Math.round((inDepotCount / activeAssets) * 100);
    if (isNaN(inDepotPercentage)) inDepotPercentage = 0;

    return {
      activePercentage,
      awaitPercentage,
      uninstalledPercentage,
      maintenancePercentage,
      notrespondingPercentage,
      activeAsset: activeAssets,
      firstActivePercentage,
      firstUninstalledPercentage,
      firstAwaitingPercentage,
      inDepotPercentage,
      realRespondingCount,
    };
  };

  loadDashboardData = async (hardwareFilter = this.state.hardwareFilter) => {
    const requestId = ++this.dashboardRequestId;
    const query = `hardwareType=${hardwareFilter}`;
    const config = this.getAuthConfig();
    const isCurrentRequest = () => requestId === this.dashboardRequestId && hardwareFilter === this.state.hardwareFilter;

    this.setState({ depotLoading: true });

    const assetRequest = axios.get(`${apiHost}/api/Assets/AssetListForDashboard?${query}`, config)
      .then((assets) => {
        if (!isCurrentRequest()) return;

        const assetData = assets.data;
        const awaitingList = assetData.awaitingInstallAssetDtoForDashbords || [];
        const uninstalledList = assetData.unInstalledAssetDtoForDashbords || [];
        const maintenanceList = assetData.maintenanceAssetDtoForDashbords || [];
        const dataSet = {
          ...this.dataSet,
          totalAsset: assetData.totalAsset,
          awaitingInstallAsset: awaitingList.length,
          uninstalledAsset: uninstalledList.length,
          maintenanceAsset: maintenanceList.length,
        };

        this.dataSet = dataSet;
        this.totalAsset = assetData.totalAsset;
        this.awaitinginstallcount = awaitingList.length;
        this.uninstallcount = uninstalledList.length;

        this.setState({
          totalAsset: assetData.totalAsset,
          awaitingCount: awaitingList.length,
          uninstalledCount: uninstalledList.length,
          maintenanceCount: maintenanceList.length,
          awaitingList,
          uninstalledList,
          maintenanceList,
          ...this.calculateDashboardMetrics(dataSet),
        });
      })
      .catch(this.handleDashboardError);

    const notRespondingRequest = axios.get(`${apiHost}/api/Assets/NotRespondingAssetForDashboard?${query}`, config)
      .then((notresponding) => {
        if (!isCurrentRequest()) return;

        const notRespondingList = notresponding.data || [];
        const dataSet = {
          ...this.dataSet,
          responding: notRespondingList.length,
        };

        this.dataSet = dataSet;
        this.notresponding = notRespondingList.length;

        this.setState({
          notrespondingCount: notRespondingList.length,
          notRespondingList,
          ...this.calculateDashboardMetrics(dataSet),
        });
      })
      .catch(this.handleDashboardError);

    const depotRequest = axios.get(`${apiHost}/api/Depots/DepotListForDashboard?${query}`, config)
      .then((depots) => {
        if (!isCurrentRequest()) return;

        const depotData = depots.data || {};
        const dataSet = {
          ...this.dataSet,
          inDepot: depotData.inDepot,
        };

        this.dataSet = dataSet;
        this.setState({
          depotList: depotData.depotAssetDtoForDashbords || [],
          totalDepots: depotData.totalDepots,
          inDepot: depotData.inDepot,
          depotLoading: false,
          ...this.calculateDashboardMetrics(dataSet),
        });
      })
      .catch((e) => {
        if (isCurrentRequest()) {
          this.setState({ depotLoading: false });
        }
        this.handleDashboardError(e);
      });

    const powercutRequest = axios.get(`${apiHost}/api/Event/PowerCutEventsForDashboard?${query}`, config)
      .then((powercuts) => {
        if (!isCurrentRequest()) return;
        this.setState({ powerCutList: powercuts.data || [] });
      })
      .catch(this.handleDashboardError);

    const duressRequest = axios.get(`${apiHost}/api/Event/DuressAlertEventsForDashboard?${query}`, config)
      .then((duress) => {
        if (!isCurrentRequest()) return;
        this.setState({ duressList: duress.data || [] });
      })
      .catch(this.handleDashboardError);

    await Promise.allSettled([
      assetRequest,
      notRespondingRequest,
      depotRequest,
      powercutRequest,
      duressRequest,
    ]);
  };

  getDuresslistData = async () => {
    // DuressAlertEventsForDashboard
    try {
      let duress = await axios.get(
        `${apiHost}/api/Event/DuressAlertEventsForDashboard?${this.getHardwareFilterQuery()}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      this.setState({
        duressList: duress.data,
      });

      this.calculations();
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      }
    }
  };

  async handleSignalR() {
    this.connection = await signalRHelper.getConnection();
    this.tunnelConnection();
  };

  tunnelConnection = () => {
    signalRHelper.subscribe('Duress');
    signalRHelper.subscribe('RealTimeAssetsAdd');
    signalRHelper.subscribe('RealTimeAssetsUpdate');
    signalRHelper.subscribe('RealTimeDepotAdd');
    signalRHelper.subscribe('RealTimeNotResponding');
    signalRHelper.subscribe('Powercut');

    this.connection.on("Duress", (data) => {
      this.data = data;
      this.getDuresslistData();
    });
    this.connection.on("RealTimeAssetsAdd", (data) => {
      this.data = data;
      this.getAssetData();
    });
    this.connection.on("RealTimeAssetsUpdate", (data) => {
      this.data = data;
      this.getAssetData();
      this.getDepotListData();
    });
    this.connection.on("RealTimeDepotAdd", (data) => {
      this.data = data;
      this.getDepotListData();
    });
    this.connection.on("RealTimeNotResponding", (data) => {
      this.data = data;
      this.getDepotListData();
      this.getNotRespondingData();
    });
    this.connection.on("Powercut", (data) => {
      this.data = data;
      this.getPowercutData();
    });
  };

  createPowercutList = (data) => {
    let counter = 0;
    let currentList = [...this.state.powerCutList];
    currentList.forEach((item, index) => {
      if (item.id == data.id) {
        currentList[index] = data;
        counter++;
      }
    });
    if (counter == 0) {
      currentList.push(data);
    }

    currentList.sort(function (x, y) {
      var date1 = new Date(x.created);
      var date2 = new Date(y.created);
      return date2 - date1;
    });

    this.setState({
      powerCutList: currentList,
    });
    this.getDepotListData();
  };

  createDuressList = (data) => {
    let counter = 0;
    let currentList = [...this.state.duressList];
    currentList.forEach((item, index) => {
      if (item.id == data.id) {
        currentList[index] = data;
        counter++;
      }
    });
    if (counter == 0) {
      currentList.push(data);
    }

    currentList.sort(function (x, y) {
      var date1 = new Date(x.created);
      var date2 = new Date(y.created);
      return date2 - date1;
    });

    this.setState({
      duressList: currentList,
    });
    this.getDepotListData();
  };

  getNotRespondingData = async () => {
    // NotRespondingAssetForDashboard
    try {
      let notresponding = await axios.get(
        `${apiHost}/api/Assets/NotRespondingAssetForDashboard?${this.getHardwareFilterQuery()}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setState({
        notrespondingCount: notresponding.data.length,
        notRespondingList: notresponding.data,
      });
      this.notresponding = notresponding.data.length;
      this.dataSet.responding = notresponding.data.length;

      this.calculations();
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      }
    }
  };
  getAssetData = async () => {
    try {
      let assets = await axios.get(
        `${apiHost}/api/Assets/AssetListForDashboard?${this.getHardwareFilterQuery()}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      let activeAssets = parseInt(assets.data.totalAsset) - parseInt(assets.data.awaitingInstallAssetDtoForDashbords.length) - parseInt(assets.data.unInstalledAssetDtoForDashbords.length) - parseInt(assets.data.maintenanceAssetDtoForDashbords.length);

      if (isNaN(activeAssets)) activeAssets = 0;

      this.setState({
        totalAsset: assets.data.totalAsset,
        awaitingCount: assets.data.awaitingInstallAssetDtoForDashbords.length,
        uninstalledCount: assets.data.unInstalledAssetDtoForDashbords.length,
        maintenanceCount: assets.data.maintenanceAssetDtoForDashbords.length,
        awaitingList: assets.data.awaitingInstallAssetDtoForDashbords,
        uninstalledList: assets.data.unInstalledAssetDtoForDashbords,
        maintenanceList: assets.data.maintenanceAssetDtoForDashbords,
        activeAsset: activeAssets,
      });

      const dataSet = {
        totalAsset: assets.data.totalAsset,
        awaitingInstallAsset: assets.data.awaitingInstallAssetDtoForDashbords.length,
        uninstalledAsset: assets.data.unInstalledAssetDtoForDashbords.length,
        maintenanceAsset: assets.data.maintenanceAssetDtoForDashbords.length,
        responding: this.dataSet.responding,
        inDepot: this.dataSet.inDepot,
      };

      this.dataSet = dataSet;
      this.calculations();
      this.totalAsset = assets.data.totalAsset;
      this.awaitinginstallcount = assets.data.awaitingInstallAssetDtoForDashbords.length;
      this.uninstallcount = assets.data.unInstalledAssetDtoForDashbords.length;
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      }
    }
  };

  calculations = (data) => {
    this.setState(this.calculateDashboardMetrics(this.dataSet));
  };

  getDepotListData = async () => {
    try {
      let depots = await axios.get(
        `${apiHost}/api/Depots/DepotListForDashboard?${this.getHardwareFilterQuery()}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setState({
        depotList: depots.data.depotAssetDtoForDashbords,
        totalDepots: depots.data.totalDepots,
        inDepot: depots.data.inDepot,
      });

      this.dataSet.inDepot = depots.data.inDepot;

      this.calculations();
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      }
    }
  };
  getPowercutData = async () => {
    // /api/Event/PowerCutEventsForDashboard

    try {
      let powercuts = await axios.get(
        `${apiHost}/api/Event/PowerCutEventsForDashboard?${this.getHardwareFilterQuery()}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (powercuts.data.length > 0) {
        this.setState({
          powerCutList: powercuts.data
        });
      }

    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      }
    }
  };
  getDashboardData = async () => {
    try {
      await axios.get(
        `${apiHost}/api/Dashboard/DashboardContent`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      }
    }
  };

  handleNanCase = (value) => { };

  sortByCreatedDesc = (list) => [...list].sort((a, b) => new Date(b.created) - new Date(a.created));

  calculatePercentage = (denominator, numerator) => {
    const value = Math.round((parseInt(numerator) / parseInt(denominator)) * 100);
    return isNaN(value) ? 0 : value;
  };

  today = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  };

  maintenanceDateStatus = (value) => {
    const date = parseMaintenanceDueDate(value);
    if (!date) return "";
    const threshold = this.getStoredMaintenanceNumber(MAINTENANCE_DATE_THRESHOLD_KEY, 7);
    const days = (date.getTime() - this.today().getTime()) / 86400000;
    if (days <= 0) return "overdue";
    if (days <= threshold) return "upcoming";
    return "";
  };

  maintenanceKmStatus = (dueKm, odometerKm) => {
    const due = toMaintenanceNumber(dueKm);
    const odometer = toMaintenanceNumber(odometerKm);
    if (due === null || due <= 0 || odometer === null) return "";
    const threshold = this.getStoredMaintenanceNumber(MAINTENANCE_KM_THRESHOLD_KEY, 2000);
    const remaining = due - odometer;
    if (remaining <= 0) return "overdue";
    if (remaining <= threshold) return "upcoming";
    return "";
  };

  maintenanceDueStatuses = (row) => (
    [
      this.maintenanceDateStatus(getMaintenanceValue(row, "registrationDue")),
      this.maintenanceDateStatus(getMaintenanceValue(row, "insuranceDue")),
      this.maintenanceDateStatus(getMaintenanceValue(row, "roadworthyDue")),
      this.maintenanceDateStatus(getMaintenanceValue(row, "serviceDueDate")),
      getMaintenanceValue(row, "isTracked") !== false
        ? this.maintenanceKmStatus(getMaintenanceValue(row, "serviceDueKm"), getMaintenanceValue(row, "odometerKm"))
        : "",
    ].filter(Boolean)
  );

  hasMaintenanceSchedule = (row) => {
    const dateValues = [
      getMaintenanceValue(row, "registrationDue"),
      getMaintenanceValue(row, "insuranceDue"),
      getMaintenanceValue(row, "roadworthyDue"),
      getMaintenanceValue(row, "serviceDueDate"),
    ];
    const hasDate = dateValues.some((value) => !!parseMaintenanceDueDate(value));
    const hasServiceKm = getMaintenanceValue(row, "isTracked") !== false
      && (toMaintenanceNumber(getMaintenanceValue(row, "serviceDueKm")) || 0) > 0;
    return hasDate || hasServiceKm;
  };

  getMaintenanceDueSummary = () => {
    const overdue = this.state.maintenanceDueRows.filter((row) => this.maintenanceDueStatuses(row).includes("overdue")).length;
    const upcoming = this.state.maintenanceDueRows.filter((row) => this.maintenanceDueStatuses(row).includes("upcoming")).length;
    const missing = this.state.maintenanceDueRows.filter((row) => !this.hasMaintenanceSchedule(row)).length;
    return {
      missing,
      overdue,
      upcoming,
      total: overdue + upcoming,
    };
  };

  renderMaintenanceDueTile = () => {
    const summary = this.getMaintenanceDueSummary();
    const isLoading = this.state.maintenanceDueLoading;
    const hasMissingSetup = !isLoading && summary.missing > 0;
    const hasDueItems = !isLoading && summary.total > 0;
    const status = summary.overdue > 0
      ? "Attention needed"
      : summary.upcoming > 0
        ? "Coming up soon"
        : hasMissingSetup
          ? "Maintenance setup needed"
          : "All assets up to date";

    return (
      <div className={`maintenance-due-summary-card${hasMissingSetup && !hasDueItems ? " setup-needed" : ""}${!hasMissingSetup && !hasDueItems && !isLoading ? " all-clear" : ""}`}>
        <div className="maintenance-due-summary-top">
          <div>
            <p>Compliance &amp; Service</p>
            <h1>{isLoading ? "..." : summary.total}</h1>
          </div>
          <button
            type="button"
            title="Open maintenance due"
            onClick={() => this.props.history.push("/maintenance-due")}
          >
            <i className="fa fa-arrow-right" aria-hidden="true"></i>
          </button>
        </div>
        {hasDueItems ? (
          <div className="maintenance-due-summary-counts">
            <button type="button" className="overdue" onClick={() => this.props.history.push("/maintenance-due?status=overdue")}>
              <span>Overdue</span>
              <strong>{summary.overdue}</strong>
            </button>
            <button type="button" className="upcoming" onClick={() => this.props.history.push("/maintenance-due?status=upcoming")}>
              <span>Upcoming</span>
              <strong>{summary.upcoming}</strong>
            </button>
          </div>
        ) : (
          <div className={`maintenance-due-summary-message${hasMissingSetup ? " setup" : " clear"}`}>
            <strong>{hasMissingSetup ? `${summary.missing} assets need setup` : "All clear"}</strong>
            <span>{hasMissingSetup ? "Enter due dates or service kilometres." : "No overdue or upcoming items."}</span>
          </div>
        )}
        <div className="maintenance-due-summary-footer">
          <span className={summary.overdue > 0 ? "overdue" : summary.upcoming > 0 ? "upcoming" : hasMissingSetup ? "setup" : "clear"}></span>
          <p>{this.state.maintenanceDueError || status}</p>
        </div>
      </div>
    );
  };

  formatDepotMetric = (denominator, numerator) => {
    const count = parseInt(numerator);
    const displayCount = isNaN(count) ? 0 : count;
    return `${displayCount} (${this.calculatePercentage(denominator, displayCount)}%)`;
  };

  escapeCsvValue = (value) => {
    if (value === null || value === undefined) {
      return "";
    }

    const stringValue = String(value);
    if (/[",\r\n]/.test(stringValue)) {
      return `"${stringValue.replace(/"/g, '""')}"`;
    }

    return stringValue;
  };

  downloadRowsAsCsv = (fileName, headers, rows) => {
    const csvRows = [headers, ...rows]
      .map((row) => row.map(this.escapeCsvValue).join(","))
      .join("\r\n");
    const blob = new Blob([csvRows], { type: "text/csv;charset=utf-8" });
    saveAs(blob, fileName);
  };

  getDashboardCsvData = () => {
    const {
      activeDashboardTab,
      depotList,
      awaitingList,
      uninstalledList,
      maintenanceList,
      notRespondingList,
      powerCutList,
      duressList,
    } = this.state;
    const dateStamp = new Date().toISOString().slice(0, 10);
    const eventHeaders = ["Name", "Depot", "Last Reported", "Occurred", "Location", "SIM", "IMEI", "Engine", "Speed"];
    const assetHeaders = ["Name", "Depot", "Last Reported", "Location", "SIM", "IMEI"];
    const assetDetailHeaders = ["Name", "Depot", "Last Reported", "Location", "SIM", "IMEI", "LogID", "Volts", "ODO"];
    const eventRow = (item) => [
      item.assetName,
      item.depotName,
      utcToDate(item.lastReported),
      utcToDate(item.created),
      item.location,
      item.sim,
      item.imei,
      item.engine ? "On" : "Off",
      rounding(item.speed),
    ];
    const assetRow = (item) => [
      item.assetName,
      item.depotName,
      utcToHomeDate(item.lastReported),
      item.location,
      item.sim,
      item.imei,
    ];
    const assetDetailRow = (item) => [
      item.assetName,
      item.depotName,
      utcToHomeDate(item.lastReported),
      item.location,
      item.sim,
      item.imei,
      item.logID,
      item.volts,
      parseInt(item.odo),
    ];

    switch (activeDashboardTab) {
      case "depots":
        return {
          fileName: `dashboard-depots-${dateStamp}.csv`,
          headers: ["Name", "Total Fleet", "Active", "Active Reporting", "Not Responding", "In Depot", "Awaiting Install", "Uninstalled", "Maintenance", "Power Cut", "Duress"],
          rows: depotList.map((depot) => [
            depot.depotName,
            depot.totalAsset,
            depot.active,
            this.formatDepotMetric(depot.active, depot.activeReporting),
            this.formatDepotMetric(depot.active, (parseInt(depot.active) || 0) - (parseInt(depot.activeReporting) || 0)),
            this.formatDepotMetric(depot.active, depot.inDepot),
            this.formatDepotMetric(depot.totalAsset, depot.awaitinginstall),
            this.formatDepotMetric(depot.totalAsset, depot.uninstalled),
            this.formatDepotMetric(depot.totalAsset, depot.maintenance),
            depot.powerCut,
            depot.duress,
          ]),
        };
      case "awaiting":
        return {
          fileName: `dashboard-awaiting-install-${dateStamp}.csv`,
          headers: assetHeaders,
          rows: awaitingList.map(assetRow),
        };
      case "uninstalled":
        return {
          fileName: `dashboard-uninstalled-${dateStamp}.csv`,
          headers: assetHeaders,
          rows: uninstalledList.map(assetRow),
        };
      case "maintenance":
        return {
          fileName: `dashboard-maintenance-${dateStamp}.csv`,
          headers: assetDetailHeaders,
          rows: maintenanceList.map(assetDetailRow),
        };
      case "notResponding":
        return {
          fileName: `dashboard-not-responding-${dateStamp}.csv`,
          headers: assetDetailHeaders,
          rows: notRespondingList.map(assetDetailRow),
        };
      case "powercuts":
        return {
          fileName: `dashboard-powercuts-${dateStamp}.csv`,
          headers: eventHeaders,
          rows: this.sortByCreatedDesc(powerCutList).map(eventRow),
        };
      case "duress":
      default:
        return {
          fileName: `dashboard-duress-${dateStamp}.csv`,
          headers: eventHeaders,
          rows: this.sortByCreatedDesc(duressList).map(eventRow),
        };
    }
  };

  downloadActiveDashboardCsv = () => {
    const { fileName, headers, rows } = this.getDashboardCsvData();
    this.downloadRowsAsCsv(fileName, headers, rows);
  };

  render() {
    const {
      depotList,
      totalDepots,
      awaitingList,
      uninstalledList,
      totalAsset,
      awaitingCount,
      uninstalledCount,
      maintenanceCount,
      notrespondingCount,
      activePercentage,
      awaitPercentage,
      uninstalledPercentage,
      maintenancePercentage,
      activeAsset,
      firstActivePercentage,
      maintenanceList,
      notRespondingList,
      powerCutList,
      duressList,
      notrespondingPercentage,
      inDepot,
      inDepotPercentage,
      realRespondingCount,
      hardwareFilter,
      activeDashboardTab,
      depotLoading,
    } = this.state;
    const awaitinstall = `<span>of <span className="goldColor">${totalAsset}</span> total fleet</span>`;
    const uninstall = `<span>of <span className="goldColor">${totalAsset}</span> total fleet</span>`;
    const activeReporting = `<span>of <span className="goldColor">${activeAsset}</span> active fleet</span>`;
    const responding = `<span>of <span className="goldColor">${totalAsset}</span> total fleet</span>`;
    const notresponding = `<span>of <span className="goldColor">  ${activeAsset}</span> active fleet </span>`;
    const depotAssets = `<span>of <span className="goldColor">${activeAsset}</span> active fleet</span>`;
    const fleetBreakdown = [
      { label: "Active Fleet", value: activeAsset, color: "#28A744" },
      { label: "Maintenance", value: maintenanceCount, color: "#FFC107" },
      { label: "Awaiting Install", value: awaitingCount, color: "#F59E0B" },
      { label: "Uninstalled", value: uninstalledCount, color: "#007BFF" },
    ];

    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>Dashboard </title>
          </Helmet>
          <div className="contentBodyHome">
            <div className="contentWrapper">
              <div className="dashboardBody">
                <HardwareFilterBox
                  selected={hardwareFilter}
                  onChange={this.handleHardwareFilterChange}
                  totalDepots={totalDepots}
                />

                <div className={`dashboardMetricGrid${this.props.showMaintenanceDueTile ? " dashboardMetricGridHome2" : ""}`}>
                  <div className="dashboardMetricCell dashboardMetricHero dashboardMetricFleet">
                    <CardBox
                      name={totalAsset}
                      icon="fa fa-truck"
                      response="total fleet"
                      tone="total"
                      progressValue={firstActivePercentage}
                      progressResponse={`${activeAsset} active fleet`}
                      textColor="#244B8F"
                      breakdown={fleetBreakdown}
                    />
                  </div>
                  {this.props.showMaintenanceDueTile && (
                    <div className="dashboardMetricCell dashboardMetricCompliance">
                      {this.renderMaintenanceDueTile()}
                    </div>
                  )}
                  <div className="dashboardMetricCell dashboardMetricReporting">
                    <CardBox
                      name={realRespondingCount}
                      icon="fa fa-heartbeat"
                      response="active reporting"
                      tone="reporting"
                      progressValue={activePercentage}
                      progressResponse={<HtmlContent html={activeReporting} />}
                      color="success"
                      textColor="#28A744"
                    />
                  </div>
                  <div className="dashboardMetricCell dashboardMetricOffline">
                    <CardBox
                      name={notrespondingCount}
                      icon="fa fa-warning"
                      response={this.props.showMaintenanceDueTile ? "offline" : "not responding"}
                      tone="notResponding"
                      progressValue={notrespondingPercentage}
                      progressResponse={<HtmlContent html={notresponding} />}
                      color="danger"
                      textColor="#DC3546"
                    />
                  </div>
	                  <div className="dashboardMetricCell dashboardMetricDepot">
	                    <CardBox
	                      name={depotLoading ? "..." : inDepot}
	                      icon="fa fa-map-marker"
	                      response="in depot"
                      tone="inDepot"
                      progressValue={inDepotPercentage}
                      progressResponse={<HtmlContent html={depotAssets} />}
                      textColor="#1796AB"
                    />
                  </div>
                  <div className="dashboardMetricCell dashboardMetricAwaiting">
                    <CardBox
                      name={awaitingCount}
                      icon="fa fa-wrench"
                      response="awaiting install"
                      tone="awaiting"
                      progressValue={awaitPercentage}
                      progressResponse={<HtmlContent html={awaitinstall} />}
                      color="dark"
                      textColor="#f59e0b"
                    />
                  </div>
                  <div className="dashboardMetricCell dashboardMetricUninstalled">
                    <CardBox
                      name={uninstalledCount}
                      icon="fa fa-archive"
                      response="uninstalled"
                      tone="uninstalled"
                      progressValue={uninstalledPercentage}
                      progressResponse={<HtmlContent html={uninstall} />}
                      textColor="#007BFF"
                    />
                  </div>
                  <div className="dashboardMetricCell dashboardMetricMaintenance">
                    <CardBox
                      name={maintenanceCount}
                      icon="fa fa-search"
                      response="maintenance"
                      tone="maintenance"
                      progressValue={maintenancePercentage}
                      progressResponse={<HtmlContent html={responding} />}
                      color="warning"
                      textColor="#FFC107"
                    />
                  </div>
                  <div className="dashboardMetricCell dashboardMetricDuress">
                    <CardBox
                      name={duressList.length}
                      icon="fa fa-bell"
                      response="duress"
                      tone="alerts"
                      progressValue={duressList.length > 0 ? 100 : 0}
                      progressResponse="active events"
                      textColor="#D05454"
                    />
                  </div>
                  <div className="dashboardMetricCell dashboardMetricPowercuts">
                    <CardBox
                      name={powerCutList.length}
                      icon="fa fa-plug"
                      response={this.props.showMaintenanceDueTile ? "power cut" : "powercuts"}
                      tone="powercuts"
                      progressValue={powerCutList.length > 0 ? 100 : 0}
                      progressResponse="active events"
                      textColor="#4C87B9"
                    />
                  </div>
                </div>
                <div className="dashboard-tabs-panel">
                  <div className="dashboard-tabs-actions">
                    <button type="button" className="dashboard-export-button" onClick={this.downloadActiveDashboardCsv}>
                      <i className="fa fa-download" aria-hidden="true"></i>
                      <span>Export CSV</span>
                    </button>
                  </div>
                  <Tabs
                    activeKey={activeDashboardTab}
                    onSelect={(activeDashboardTab) => this.setState({ activeDashboardTab: activeDashboardTab || "duress" })}
                    id="dashboard-detail-tabs"
                    className="dashboard-tabs"
                    mountOnEnter
                  >
                    <Tab
                      eventKey="duress"
                      title={<span>Duress <strong>{duressList.length}</strong></span>}
                    >
                      <DuressTable duressList={duressList}></DuressTable>
                    </Tab>
                    <Tab
                      eventKey="depots"
                      title={<span>Depots <strong>{depotList.length}</strong></span>}
                    >
                      <DepotTable depotList={depotList}></DepotTable>
                    </Tab>
                    <Tab
                      eventKey="awaiting"
                      title={<span>Awaiting Install <strong>{awaitingList.length}</strong></span>}
                    >
                      <AwaitingTable awaitingList={awaitingList}></AwaitingTable>
                    </Tab>
                    <Tab
                      eventKey="uninstalled"
                      title={<span>Uninstalled <strong>{uninstalledList.length}</strong></span>}
                    >
                      <AwaitingTable awaitingList={uninstalledList}></AwaitingTable>
                    </Tab>
                    <Tab
                      eventKey="maintenance"
                      title={<span>Maintenance <strong>{maintenanceList.length}</strong></span>}
                    >
                      <UninstalledTable
                        unInstalledList={maintenanceList}
                      ></UninstalledTable>
                    </Tab>
                    <Tab
                      eventKey="notResponding"
                      title={<span>Offline <strong>{notRespondingList.length}</strong></span>}
                    >
                      <UninstalledTable
                        unInstalledList={notRespondingList}
                      ></UninstalledTable>
                    </Tab>
                    <Tab
                      eventKey="powercuts"
                      title={<span>Powercuts <strong>{powerCutList.length}</strong></span>}
                    >
                      <PowercutTable powerCutList={powerCutList}></PowercutTable>
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

export default Home;
